import React, { useEffect, useRef,useImperativeHandle } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { capitalize, Typography } from "@mui/material";

import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import "../CSS/bill.css";

const PdfDownloadComponent = React.forwardRef(({ rideBookingDTO , billGeneratedDate },ref) => {
  const templateRef = useRef();

  const generateAndDownloadPdf = async () => {
    const element = templateRef.current;

    // Temporarily make the hidden content visible for rendering
    element.style.display = 'block';

    // Check if element exists before calling html2canvas
    if (element) {
      try {
        const A4_WIDTH = 900;
        const A4_HEIGHT = 1200;

        // Render the canvas with A4 dimensions
        const canvas = await html2canvas(element, {
          scale: 3,
          useCORS: true, // High scale for better resolution
          width: A4_WIDTH,
          height: A4_HEIGHT,
        }); const imgData = canvas.toDataURL("image/jpeg", 1.0);

     //   element.style.display = 'none';
        const pdf = new jsPDF("p", "mm", "a4");
        const margin = 3;

        // Calculate the width and height for the PDF
        const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * 3;
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        // Add the image (content) to the PDF and download
        pdf.addImage(imgData, "JPEG", 2, 2, pdfWidth, pdfHeight);
        pdf.save("RideBookingDetails.pdf");

      
      } catch (error) {
        console.error('Error generating PDF:', error);
      }
    } else {
      console.error('The element is not available for PDF generation.');
    }
  };

  // Expose the generateAndDownloadPdf method to parent via ref
  useImperativeHandle(ref, () => ({
    //generateAndDownloadPdf,
  }));
    

//    generateAndDownloadPdf();
 // Run when rideBookingDTO changes

  const formatDate = (date) => {
    const options = { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit" };
    return new Date(date).toLocaleString("en-US", options);
  };

  const calculateTotalAmount = () => {
    if(rideBookingDTO!={} && rideBookingDTO!=null){
      const totalAmount =
      (Number(rideBookingDTO.rentPerKM) * Number(rideBookingDTO.totalKM)) +
      Number(rideBookingDTO.driverFee) +
      Number(rideBookingDTO.tollCharge) +
      Number(rideBookingDTO.extraCharge) +
      (Number(rideBookingDTO.rentPerDay) * Number(rideBookingDTO.numberOfDays));

    return totalAmount ? totalAmount.toFixed(2) : "0.00";
}
return "";
  };

  return (
    <div>
      <div >
    <div  ref={templateRef} style={{fontFamily: "Arial, sans-serif",width:'900px',height:'1200px',display:'none'}} >
    <div className="header" style={{ display: "flex", justifyContent: "space-between", backgroundColor: "#333", color: "white", borderRadius: "10px", padding:'10px' }}>
  <div style={{  }}>
    <p style={{margin:0}}>3/82 , ERIKKADAI ,</p>
    <p style={{margin:0}}>VEERAPANDI,Periyaseeragapadi</p>
    <p style={{margin:0}}>Salem, Tamil Nadu, 636308</p>
    <p style={{margin:0}}>Phone: 9965821750</p>
    <p style={{margin:0}}>Email: vrsslm92@gmail.com</p>
  </div>
  <div style={{ marginRight: "20px", display: "flex", justifyContent: "flex-end" }}>
    <img src="/images/login/locationInSVR.png" alt="Company Logo" width="100" height="100" />
  </div>
</div>

      <div className="bill-info" style={{ textAlign: "right"}}>
        <p>
          Customer Name: <span style={{fontWeight:'normal',fontSize:'16px'}}> {capitalize(String(rideBookingDTO?.customerName))} </span>
        </p>
        <p>
          Bill Generation Date:<span style={{fontWeight:'normal'}}> {billGeneratedDate? billGeneratedDate.toLocaleString() : ''} </span>
        </p>
      </div>

      <h2 style={{ textAlign: "center",marginTop:'30px',fontWeight:'bolder' }}>SVR Taxi Service Bill</h2>

      <h3 style={{textAlign:"left",marginTop:'30px',fontWeight:'bolder',fontSize:'22px'}}>Basic Details : </h3>
      <div className="basic-details" style={{display:'flex',justifyContent:'center'}}>      
        <table className=" table-striped"  style={{ borderCollapse: "collapse", marginTop: "5px",border:"1px solid #ddd" }}>
        <tbody>
          <tr style={{ backgroundColor: "#90d5ff" }}>
            <td className="column-name">Pickup Location</td>
            <td>{capitalize(String(rideBookingDTO?.pickupLocation))}</td>
            <td className="column-name" colSpan={2}>Drop Location</td>
            <td colSpan={2}>{capitalize(String(rideBookingDTO?.dropLocation))}</td>
          </tr>
          <tr>
            <td className="column-name">Pickup Date and Time</td>
            <td>{formatDate(rideBookingDTO?.pickupDateTime)}</td>
            <td className="column-name" colSpan={2}>Return Date and Time</td>
            <td colSpan={2}>{formatDate(rideBookingDTO?.returnDateTime)}</td>
          </tr>
          <tr>
            <td className="column-name">Car Model</td>
            <td>{rideBookingDTO?.carModel}</td>
            <td className="column-name" colSpan={2}>Customer Mobile No</td>
            <td colSpan={2}>{rideBookingDTO?.phoneNumber}</td>
          </tr>
          <tr>
            <td className="column-name">Opening KM</td>
            <td>{rideBookingDTO?.openingKM}</td>
            <td className="column-name"  colSpan={2}>Closing KM</td>
            <td>{rideBookingDTO?.closingKM}</td>
          </tr>
        </tbody>
      </table>
      </div>

      <h3 style={{textAlign:"left",marginTop:'25px',fontWeight:'bolder',fontSize:'22px'}}>Billing Details : </h3>
      <div style={{display:'flex',justifyContent:'center'}}>    
      <table className=" table-striped" style={{borderCollapse: "collapse", marginTop: "20px",border:'1px solid #ddd' }}>
        <thead className="bill-table-thead" >
          <tr>
            <th>Description</th>
            <th>Single Price</th>
            <th>Kilometer</th>
            <th></th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Total Kilometers</td>
            <td><CurrencyRupeeIcon style={{width: '20px'}} />{rideBookingDTO?.rentPerKM}</td>
            <td>{rideBookingDTO?.totalKM}</td>
            <td>-</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{Number(rideBookingDTO?.rentPerKM * rideBookingDTO?.totalKM).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Rent</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.rentPerDay}</td>
            <td>-</td>
            <td>{rideBookingDTO?.numberOfDays}</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{Number(rideBookingDTO?.rentPerDay * rideBookingDTO?.numberOfDays).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Driver Fee</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.driverFee}</td>
            <td>-</td>
            <td>-</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{Number(rideBookingDTO?.driverFee).toFixed(2)}</td>
          </tr>
          <tr>
            <td>Toll Charge</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.tollCharge}</td>
            <td>-</td>
            <td>-</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.tollCharge}</td>
          </tr>
          <tr>
            <td>Extra Charge</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.extraCharge}</td>
            <td>-</td>
            <td>-</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.extraCharge}</td>
          </tr>
        </tbody>
      </table>
</div>
      <p style={{ fontWeight: "bolder", fontSize: "1.2em", textAlign: "right", marginTop: "10px",marginRight:'50px'}}>
      Total Amount: <CurrencyRupeeIcon style={{width: '20px'}} /> {calculateTotalAmount()}
      </p>

      <h3 style={{textAlign:"left",fontWeight:'bolder',fontSize:'22px'}}>Amount Details : </h3>
      <div style={{display:'flex',justifyContent:'center'}}>  
      <table  style={{  borderCollapse: "collapse", marginTop: "5px",border:'1px solid #ddd' }}>
        <thead className="bill-table-thead" style={{color:'#fff'}}>
          <tr>
            <th>Total Amount</th>
            <th>Received Amount</th>
            <th>Balance</th>
            <th>Mode of Payment</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{calculateTotalAmount()}</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{rideBookingDTO?.receivedAmount}</td>
            <td><CurrencyRupeeIcon  style={{width: '20px'}} />{calculateTotalAmount() - rideBookingDTO?.receivedAmount}</td>
            <td>{rideBookingDTO?.modeOfPayment}</td>
          </tr>
        </tbody>
      </table>
      
  </div>
      <div>
  <table  style={{textAlign: "center", justifyContent: "center",borderRadius:'10px',marginTop:'40px',backgroundColor:'darkgray'}}>
    <tbody>
      <tr>
        <td style={{ border:'none' }}>
          <span>
            <p style={{ margin: "0px", fontWeight: "bold", fontSize: "20px" }}>
              Thanks for choosing SVR Taxi services
            </p>
            <p style={{ margin: "5px 0", fontSize: "14px" }}>
              <a
                href="https://salemsvrtaxi.netlify.app"
                style={{ textDecoration: "none", color: "#007BFF" }}
              >
                svrtaxi.netlify.app
              </a>
            </p>
          </span>
        </td>
        <td style={{border:'none'}}>
          <span>
            <p style={{ margin: "0", fontWeight: "bold",fontSize:'16px' }}>
              For SVR Taxi Proprietor Manager
            </p>
            <p style={{ fontWeight: "bold",fontSize:'16px' }}>
              Varatharajan . S
            </p>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

    </div>
    </div>

<button onClick={generateAndDownloadPdf}>Download PDF</button>
</div>
  );
});


export default PdfDownloadComponent;
